import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAiohttpComponent } from './simple-icons-aiohttp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAiohttpComponent ],
    exports:      [ SimpleIconsAiohttpComponent ],
    bootstrap:    []
})
export class SimpleIconsAiohttpModule {}
